/**
 * @file
 * @author zhousheng
 */
import * as React from 'react';
import defaultLocaleData from './default';
import LocaleContext from './context';
export default class LocaleReceiver extends React.Component {
    getLocale() {
        const { componentName, defaultLocale } = this.props;
        const locale = defaultLocale || defaultLocaleData[componentName || 'global'];
        const acudLocale = this.context;
        const localeFromContext = componentName && acudLocale ? acudLocale[componentName] : {};
        return Object.assign(Object.assign({}, (typeof locale === 'function' ? locale() : locale)), (localeFromContext || {}));
    }
    getLocaleCode() {
        const acudLocale = this.context;
        const localeCode = acudLocale && acudLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if (acudLocale && acudLocale.exist && !localeCode) {
            return defaultLocaleData.locale;
        }
        return localeCode;
    }
    render() {
        return this.props.children(this.getLocale(), this.getLocaleCode(), this.context);
    }
}
LocaleReceiver.defaultProps = {
    componentName: 'global'
};
LocaleReceiver.contextType = LocaleContext;
export function useLocaleReceiver(componentName, defaultLocale) {
    const acudLocale = React.useContext(LocaleContext);
    const componentLocale = React.useMemo(() => {
        const locale = defaultLocale || defaultLocaleData[componentName || 'global'];
        const localeFromContext = componentName && acudLocale ? acudLocale[componentName] : {};
        return Object.assign(Object.assign({}, (typeof locale === 'function' ? locale() : locale)), (localeFromContext || {}));
    }, [componentName, defaultLocale, acudLocale]);
    return [componentLocale];
}
